export default __webpack_public_path__ + "static/media/appstore.969642b4.svg";